export default "__VITE_ASSET__CTh27v8b__"